import { createFileRoute } from '@tanstack/react-router'
import { Coins } from 'lucide-react'
import { CreditsScreen } from '@/screens/billing/SCR-166-credits'

export const Route = createFileRoute('/_app/billing/credits')({
  staticData: { screen: { id: 'SCR-166', title: 'Credits', group: 'Organisation', perm: ['billing.read', 'billing.manage'], order: 13, description: 'Your credit balance, what used it, and top-ups.', icon: Coins } },
  component: CreditsScreen,
})
